export const KEY_FILTERS = 'f';

export const KEY_TEXT_SEARCH = 's';
export const KEY_COMPANY = 'c';

export const BASE_URL_CUSTOMERS = '/admin/customers';
export const BASE_URL_USERS = '/admin/users';
